import React, { useRef } from "react";
import { Container } from "@UI/Components/Container/Container";
import { HStack, VStack } from "@UI/Components/Stack/Stack";
import {
  ICandidate,
  ICandidateCardProps,
  ICandidateOfferModalProps,
} from "../../types";
import { CandidateProfileSection } from "./CandidateProfileSection";
import { CandidateAvatar } from "./CandidateAvatar";
import { CandidateActions } from "./CandidateActions";
import { CandidateOfferSection } from "./CandidateOfferSection";
import { CandidateProximityAndJobDoneCountSection } from "./CandidateProximityAndJobDoneCountSection";
import { Offcanvas } from "bootstrap";

export const CandidateCard = (
  props: ICandidate &
    ICandidateCardProps &
    Pick<ICandidateOfferModalProps, "onDeclineOfferModalOpen">
) => {
  const buttonRef = useRef(null);

  const openOffcanvas = () => {
    const el = document.getElementById(`offcanvas-profil-sp-${props.id}`);
    if (el) {
      Offcanvas.getOrCreateInstance(el).show();
    }
  };

  const onRootClick = (e: React.MouseEvent) => {
    // Skip if a child marked to prevent opening was clicked
    if ((e.target as HTMLElement).closest("[data-stop-offcanvas]")) return;
    openOffcanvas();
  };

  return (
    <Container
      data-testid={`candidate-card`}
      display="flex"
      flexDir="column"
      gap="16px"
      background="white"
      p={{ base: "16px", lg: "24px" }}
      borderRadius="10px"
      m={0}
      maxW="100%"
    >
      <HStack
        as="button"
        ref={buttonRef}
        spacing={{ md: "16px" }}
        onClick={onRootClick}
      >
        <CandidateAvatar
          display={{ base: "none", md: "initial" }}
          size="lg"
          isSuperTalent={props.superTalent}
          url={props.profilePicture}
        />
        <VStack spacing="16px" w="full" alignItems="start">
          <HStack
            w="inherit"
            spacing="12px"
            flexDir="row"
            justifyContent="space-between"
          >
            <CandidateProfileSection
              {...props}
              profileNameStyle={{ lineHeight: { base: "27px", lg: "36px" } }}
              superTalent={props.superTalent}
              avatarSection={
                <CandidateAvatar
                  display={{ md: "none" }}
                  isSuperTalent={props.superTalent}
                  url={props.profilePicture}
                />
              }
            />
            <CandidateOfferSection {...props} />
          </HStack>
          <CandidateProximityAndJobDoneCountSection {...props} />
        </VStack>
      </HStack>
      <CandidateActions
        conversationId={props.conversationId}
        offerAsked={props.offerAsked}
        offerWithdrawn={props.offerWithdrawn}
        hasServiceOffer={!!props.serviceOffer}
        isLoading={false}
        hasUnreadMessages={props.unreadConversationCommentsCount > 0}
        onCandidateOfferModalOpen={props.onCandidateOfferModalOpen}
        removeUnreadIndicatorFromConversation={
          props.removeUnreadIndicatorFromConversation
        }
        onDeclineOfferModalOpen={props.onDeclineOfferModalOpen}
      />
    </Container>
  );
};
